// Init jQuery stuff

import 'expose-loader?jQuery!expose-loader?$!jquery';
import debounce from 'lodash/debounce';

export function init() {
	$(function () {

		//-----------------
		// Navbar

		var $tabs = $('#header').find('ul.navbar-nav'),
			tabsHeight = $tabs.height(),
			$window = $(window),
			$body = $(document.body),
			mini = false;
		$window.scroll(debounce(function () {
			var scrollTop = $window.scrollTop();
			if (scrollTop > tabsHeight) {
				if (!mini) {
					$body.toggleClass('header-mini', true);
					mini = true;
				}
			} else if (scrollTop === 0 && mini) {
				$body.toggleClass('header-mini', false);
				mini = false;
			}
		}, 60));

		//-----------------
		// Inputs

		$(document).on('focus blur', '.form-control', function (e) {
			var $target = $(e.currentTarget);
			$target.closest('.form-group').toggleClass('form-group-focused', $target.is(':focus'));
		});
	});
}


// WEBPACK FOOTER //
// ./src/ui/jqinit.js